import { useParams, useSearchParams } from 'react-router-dom';
import * as AdaptiveCards from "adaptivecards";
import * as ACData from "adaptivecards-templating";
import styles from './schedule-expiry.module.scss';
import  "../../../i18n/translation";
import { useTranslation } from "react-i18next";
import { app, dialog } from "@microsoft/teams-js";

interface ScheduleExpiryProps { }

export const ScheduleExpiry = (props: ScheduleExpiryProps) => {

    const { t } = useTranslation();
    const { scope, lang, replyToId } = useParams();
    const _data = JSON.stringify({ "ReplyId": replyToId });
    const response = { taskComponentName: "ScheduleSubmissionExpired", data: _data };
    const cardBody = {
        "type": "AdaptiveCard",
        "version": "1.5",
        "body": [
            {
                "type": "TextBlock",
                "size": "Large",
                "wrap": true,
                "weight": "Bolder",
                "spacing": "ExtraLarge",
                "horizontalAlignment": "Center",
                "text": "${header}"
            },
            {
                "type": "TextBlock",
                "wrap": true,
                "horizontalAlignment": "Center",
                "text": "${channelScopeText}",
                "$when": "${scope != 'personal'}"
            },
            {
                "type": "TextBlock",
                "wrap": true,
                "horizontalAlignment": "Center",
                "text": "${personalScopeText}",
                "$when": "${scope == 'personal'}"
            }
        ]
    };

    const template = new ACData.Template(cardBody);
    const cardPayload = template.expand({
        $root: {
            "scope": scope,
            "header": t("TAB_74"),
            "personalScopeText": t("TAB_76"),
            "channelScopeText": t("TAB_75")
        }
    });
    
    const adaptiveCard = new AdaptiveCards.AdaptiveCard();
    adaptiveCard.version = new AdaptiveCards.Version(1, 5);
    adaptiveCard.parse(cardPayload);
    const renderedCard = adaptiveCard.render()!;

    const submitTaskModule = () => {
        app.initialize();
        const data = JSON.stringify({ "ReplyId": replyToId })
        const response = { taskComponentName: "ScheduleSubmissionExpired", data: data };
        dialog.url.submit(response);
        dialog.url.submit();
    }

    return (
        <div>
            <div className={`${styles['cardHolder']}`} ref={(n) => {
                n && n.firstChild && n.removeChild(n.firstChild);
                n && n.appendChild(renderedCard);
            }} />
            <div className={`${styles['btnHolder']}`}>
                <button className={`${styles['teams-button-default']}`} onClick={() => submitTaskModule()} type="button">{t("TAB_77")}</button>
            </div>
        </div>
    );
};